import { mainClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import { IMeta, IStore } from 'src/common/interfaces/index.js'

const IInsertResponse = { meta: IMeta, data: IStore }
const IListResponse = { meta: IMeta, data: [IStore] }

export const store = {
  /**
   * @param {IStore} data
   * @param {{id: number}} [filter={}]
   * @return {IInsertResponse}
   */
  insert(data, filter, signal) {
    return mainClient.post('store/insert', { data, filter }, { signal })
  },

  /**
   * @param {{id: number}} [filter={}]
   * @return {Promise<IListResponse>}
   */
  list(filter, signal) {
    return mainClient.post('store/list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number}} filter
   * @returns {Promise<{list: string[]}>}
   */
  confirmation(filter, signal) {
    return businessClient().post('store/archive/confirmation', { filter }, { signal })
  },
  archiveAction(filter, signal) {
    return businessClient().post('store/archive/action', { filter }, { signal })
  },
}
